import { Layout } from '@/core/layout';
import { RouteRecordRaw } from 'vue-router';

export enum CheckoutRoute {
    Checkout = 'checkout',
}

export const routes: RouteRecordRaw = {
    path: '/checkout/:transaction_id',
    name: CheckoutRoute.Checkout,
    meta: {
        layout: Layout.HeaderOnly,
    },
    component: () => import('./CheckoutPage.vue'),
};
